import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Box,
  Typography,
  Collapse,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import StarIcon from "@mui/icons-material/Star";
import SendIcon from "@mui/icons-material/Send";
import DraftsIcon from "@mui/icons-material/Drafts";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MailIcon from "@mui/icons-material/Mail";
import DeleteIcon from "@mui/icons-material/Delete";
import ArchiveIcon from "@mui/icons-material/Archive";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LabelIcon from "@mui/icons-material/Label";
import ForwardIcon from "@mui/icons-material/Forward";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import ArticleIcon from "@mui/icons-material/Article";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { Link, NavLink } from "react-router-dom";
import '../style/style.css';
import "bootstrap/dist/css/bootstrap.min.css";
// Menu items with their respective submenus
const menuItems = [
  {
    text: "Brands",
    icon: <InboxIcon />,
    path: '/' ,   
    // subMenu: [
    //   { text: "Primary", icon: <MailIcon /> },
    //   { text: "Archived", icon: <ArchiveIcon /> },
    //   { text: "Trash", icon: <DeleteIcon /> },
    // ]
  },

  // {
  //   text: "Menu",
  //   icon: <InboxIcon />,
  //   path: '/menu'        
  // },


  // {
  //   text: "Starred",
  //   icon: <StarIcon />,
  //   subMenu: [
  //     { text: "Favorites", icon: <FavoriteIcon /> },
  //     { text: "Bookmarks", icon: <BookmarkIcon /> },
  //     { text: "Labels", icon: <LabelIcon /> },
  //   ]
  // },
   
];

const Sidebar = ({ mobileOpen, handleDrawerToggle, isMobile }) => {
  const [openStates, setOpenStates] = useState({});

  const handleMenuClick = (text) => {
    setOpenStates(prev => ({
      ...prev,
      [text]: !prev[text]
    }));
  };

  const drawerContent = (
    <>
      <Typography variant="body1" sx={{textAlign:"center"}}>
        {/* Wall Paper */}
      </Typography>  

      <Toolbar />

      <List>
        {menuItems.map((item) => (
          <React.Fragment key={item.text}>
            <NavLink
              to={`${item.path}`}
              style={({ isActive }) => ({
                textDecoration: 'none',
                // color: isActive ? 'white' : 'black',
                color: 'black',
                backgroundColor: isActive ? '#91d6eb' : 'white',
                display: 'block'
              })}
            >
              <ListItem
                button
                onClick={() => handleMenuClick(item.text)}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(139, 69, 19, 0.1)'
                  },
                  '& .MuiListItemText-root': {
                    color: 'inherit'
                  },
                  '&.active': {
                    backgroundColor: '#8B4513',
                    color: 'white',
                    '& .MuiListItemIcon-root': {
                      color: 'white'
                    }
                  }
                }}
                className={({ isActive }) => isActive ? 'active' : ''}
              >

                <ListItemIcon
                  sx={{
                    color: 'inherit'
                  }}
                >
                  {item.icon}
                </ListItemIcon>

                <ListItemText primary={item.text} />

                { 
                  item?.subMenu?.length > 0 &&
                  (openStates[item.text] ? <ExpandLess /> : <ExpandMore />)
                }

              </ListItem>
            </NavLink>

            {/* Submenu items */}
            {item?.subMenu?.length > 0 && (
              <Collapse in={openStates[item.text]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.subMenu.map((subItem) => (
                    <ListItem
                      button
                      key={subItem.text}
                      sx={{
                        pl: 4,
                        '&:hover': {
                          backgroundColor: 'rgba(139, 69, 19, 0.1)'
                        },
                        '&.active': {
                          backgroundColor: '#8B4513',
                          color: 'white',
                          '& .MuiListItemIcon-root': {
                            color: 'white'
                          }
                        }
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color: 'inherit'
                        }}
                      >
                        {subItem.icon}
                      </ListItemIcon>
                      <ListItemText primary={subItem.text} />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}

          </React.Fragment>
        ))}
      </List>
    </>
  );

  return (
    <Box      
      component="nav"
      sx={{ width: { sm: 240 }, flexShrink: { sm: 0 }}}
    >
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },                  
        }}
      >
        {drawerContent}
      </Drawer>
      
      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default Sidebar;

